import {BaseFilterOption} from '@/types/models/creator-crm/filter';

export const defaultAgeFilterOptions: BaseFilterOption[] = [
  {
    localeLabelKey: '13-17',
    id: '13-17',
    value: {fromAge: 13, toAge: 17},
  },
  {
    localeLabelKey: '18-24',
    id: '18-24',
    value: {fromAge: 18, toAge: 24},
  },
  {
    localeLabelKey: '25-34',
    id: '25-34',
    value: {fromAge: 25, toAge: 34},
  },
  {
    localeLabelKey: '35-44',
    id: '35-44',
    value: {fromAge: 35, toAge: 44},
  },
  {
    localeLabelKey: '45-64',
    id: '45-64',
    value: {fromAge: 45, toAge: 64},
  },
  {
    localeLabelKey: '65+',
    id: '65+',
    value: {fromAge: 65},
  },
];

export const defaultGenderFilterOptions: BaseFilterOption[] = [
  {
    localeLabelKey: 'All',
    id: 'all',
    value: null,
  },
  {
    localeLabelKey: 'Female',
    id: 'female',
    value: 'female',
  },
  {
    localeLabelKey: 'Male',
    id: 'male',
    value: 'male',
  },
  {
    localeLabelKey: 'Other',
    id: 'other',
    value: 'other',
  },
];

export const engagementRateFilterOptions: BaseFilterOption[] = [
  {
    localeLabelKey: '1%',
    id: '1%',
    value: 0.01,
  },
  {
    localeLabelKey: '2%',
    id: '2%',
    value: 0.02,
  },
  {
    localeLabelKey: '3%',
    id: '3%',
    value: 0.03,
  },
  {
    localeLabelKey: '4%',
    id: '4%',
    value: 0.04,
  },
  {
    localeLabelKey: '5%',
    id: '5%',
    value: 0.05,
  },
  {
    localeLabelKey: '6%',
    id: '6%',
    value: 0.06,
  },
  {
    localeLabelKey: '7%',
    id: '7%',
    value: 0.07,
  },
  {
    localeLabelKey: '8%',
    id: '8%',
    value: 0.08,
  },
  {
    localeLabelKey: '9%',
    id: '9%',
    value: 0.09,
  },
  {
    localeLabelKey: '10%',
    id: '10%',
    value: 0.1,
  },
  {
    localeLabelKey: '11%',
    id: '11%',
    value: 0.11,
  },
  {
    localeLabelKey: '12%',
    id: '12%',
    value: 0.12,
  },
  {
    localeLabelKey: '13%',
    id: '13%',
    value: 0.13,
  },
  {
    localeLabelKey: '14%',
    id: '14%',
    value: 0.14,
  },
  {
    localeLabelKey: '15%',
    id: '15%',
    value: 0.15,
  },
  {
    localeLabelKey: '16%',
    id: '16%',
    value: 0.16,
  },
  {
    localeLabelKey: '17%',
    id: '17%',
    value: 0.17,
  },
  {
    localeLabelKey: '18%',
    id: '18%',
    value: 0.18,
  },
  {
    localeLabelKey: '19%',
    id: '19%',
    value: 0.19,
  },
  {
    localeLabelKey: '20%',
    id: '20%',
    value: 0.2,
  },
];

export const defaultPlatformFilterOptions: BaseFilterOption[] = [
  {
    localeLabelKey: 'All',
    id: 'all',
    value: null,
  },
  {
    localeLabelKey: 'Instagram',
    id: 'instagram',
    value: 'instagram',
  },
  {
    localeLabelKey: 'TikTok',
    id: 'tiktok',
    value: 'tiktok',
  },
  {
    localeLabelKey: 'YouTube',
    id: 'youtube',
    value: 'youtube',
  },
  {
    localeLabelKey: 'Facebook',
    id: 'facebook',
    value: 'facebook',
  },
  {
    localeLabelKey: 'Pinterest',
    id: 'pinterest',
    value: 'pinterest',
  },
  {
    localeLabelKey: 'Twitter',
    id: 'twitter',
    value: 'twitter',
  },
];

export const defaultVettingDecisionFilterOptions: BaseFilterOption[] = [
  {id: 'approved', localeLabelKey: 'Approved', value: 'approved'},
  {id: 'declined', localeLabelKey: 'Declined', value: 'declined'},
  {
    id: 'ready_for_review',
    localeLabelKey: 'Ready for Review',
    value: 'ready_for_review',
  },
];

export const defaultCampaignHistoryFilterOptions: BaseFilterOption[] = [
  {
    id: 'worked_with_brand',
    localeLabelKey: 'Worked with {brand_name}',
    value: 'worked_with_brand',
  },
  {
    id: 'worked_with_org',
    localeLabelKey: 'Worked with {agency_name}',
    value: 'worked_with_org',
  },
  {
    id: 'never_worked_with_brand',
    localeLabelKey: 'Never worked with {brand_name}',
    value: 'never_worked_with_brand',
  },
  {
    id: 'never_worked_with_org',
    localeLabelKey: 'Never worked with {agency_name}',
    value: 'never_worked_with_org',
  },
];
